<template>
  <gd-modal name="ads-modal" width="100%" height="100%">
    <div ref="container" class="h-full">
      <div class="flex flex-row justify-between p-4">
        <div class="h-full font-bold text-xl text-grey-700">
          {{ $t('frontend_ads_title') }}
        </div>
        <div class="flex flex-row justify-end">
          <gd-button class="mr-4" @click="close">
            {{ $t('frontend_exit') }}
          </gd-button>
          <gd-button primary @click="addAds">
            {{ $t('frontend_add') }}
          </gd-button>
        </div>
      </div>
      <div ref="adsContainer" class="h-full flex flex-row bg-grey-900 pb-16">
        <div class="flex flex-row flex-grow flex-wrap overflow-auto">
          <info-panel v-if="!ads.length" class="m-4">
            <template slot="content">
              <div
                class="
                  w-full
                  h-full
                  flex
                  justify-center
                  items-center
                  text-lg text-grey-900 text-center
                "
              >
                {{ $t('frontend_ads_not_found') }}
              </div>
            </template>
            <template slot="footer">
              <div class="w-full h-full flex justify-center items-center">
                <gd-button primary size="large" @click="addAds">
                  {{ $t('frontend_add') }}
                </gd-button>
              </div>
            </template>
          </info-panel>
          <info-panel
            style="height: auto"
            v-for="ad in ads"
            :key="ad.id"
            class="m-4"
          >
            <template slot="content">
              <div class="w-full h-full rounded-t-lg">
                <img
                  class="w-full h-full rounded-t-lg bg-center"
                  :src="ad.image_url"
                />
              </div>
            </template>
            <template slot="footer">
              <div
                class="
                  w-full
                  h-full
                  flex flex-row
                  justify-between
                  items-center
                  px-4
                "
              >
                <div class="w-56 break-words">
                  {{ ad.trigger_url }}
                  <br />
                  <span v-if="ad.is_active == 1" class="text-sm text-green">
                    {{ $t('frontend_active') }}
                  </span>
                  <span v-else class="text-sm text-red"> {{ $t('frontend_paused') }} </span>
                </div>
                <drop-menu :menu-items="menuItems(ad)" small />
              </div>
            </template>
          </info-panel>
        </div>
        <side-bar ref="sidebar" sections="Ads" :title="sidebarTitle">
          <div class="mx-4 mt-2">
            <image-picker-modal
              v-model="image"
              label="Image"
              remove-padding="true"
            />
            <text-input v-model="url" placeholder="Trigger URL" dark />
          </div>
          <div class="mt-8 w-full flex flex-row justify-center">
            <gd-button
              :disabled="!isValid"
              :primary="isValid"
              size="large"
              @click="saveAds()"
              >{{ $t('frontend_save') }}</gd-button
            >
          </div>
        </side-bar>
      </div>
    </div>
    <confirm-modal
      ref="deleteModal"
      name="delete-ads"
      :callback="confirmDelete"
    ></confirm-modal>
    <confirm-modal
      ref="AdStatusModal"
      name="status-ads"
      :confirmMessage="messageStatus"
      :callback="confirmStatus"
    ></confirm-modal>
  </gd-modal>
</template>

<script>
import api from '@groovepages/gd-lib/api';
import Notify from '@groovepages/gd-lib/notify';
import GdButton from './Button';
import TextInput from './TextInput';
import DropMenu from './DropMenu';
import GdDropdown from './Dropdown';
import GdModal from './Modal';
import SideBar from './SideBar';
import InfoPanel from './InfoPanel';
import ImagePickerModal from './ImagePickerModal';
import ConfirmModal from './ConfirmModal';

export default {
  name: 'AdsModal',
  components: {
    GdButton,
    TextInput,
    DropMenu,
    GdDropdown,
    SideBar,
    InfoPanel,
    GdModal,
    ConfirmModal,
    ImagePickerModal,
  },
  data() {
    return {
      ads: [],
      url: '',
      image: '',
      status: '',
      toEdit: '',
      toDelete: '',
      toStatus: '',
      messageStatus: '',
    };
  },
  computed: {
    isValid() {
      if (this.image && this.url) return true;
      return false;
    },
    sidebarTitle() {
      if (!this.toEdit) return this.$t('frontend_add');
      return this.$t('frontend_edit');
    },
  },
  methods: {
    menuItems(ad) {
      const action = {
        text: '',
        callback: () => this.changeAdStatus(ad),
      };
      if (ad.is_active == 1) {
        action.text = this.$t('frontend_pause');
      } else {
        action.text = this.$t('frontend_resume');
      }
      return [
        { text: this.$t('frontend_edit'), callback: () => this.editAds(ad) },
        action,
        {
          text: this.$t('frontend_delete'),
          callback: () => this.deleteAds(ad),
        },
      ];
    },
    changeAdStatus(ad) {
      if (ad.is_active == 1) {
        this.messageStatus = this.$t('frontend_adsModal_pause_this_ad');
      } else {
        this.messageStatus = this.$t('frontend_adsModal_resume_this_ad');
      }
      this.toStatus = ad;
      this.$refs.AdStatusModal.open();
    },
    open() {
      this.initAds();
      this.$root.$emit('modal-open', 'ads-modal');
    },
    close() {
      this.$root.$emit('modal-close', 'ads-modal');
    },
    initAds() {
      api
        .get(`${window.gdEnv.VUE_APP_API_URL}/groovedigital/ad`)
        .then((data) => {
          this.ads = data || [];
        })
        .catch((err) => this.showError(err));
    },
    addAds() {
      this.url = '';
      this.image = '';
      this.status = 1;
      this.toEdit = '';
      this.$refs.sidebar.open();
    },
    editAds(ad) {
      this.toEdit = ad;
      this.url = ad.trigger_url;
      this.image = ad.image_url;
      this.status = ad.is_active;
      this.$refs.sidebar.open();
    },
    confirmStatus() {
      let status;
      if (this.toStatus.is_active == 1) {
        status = 0;
      } else {
        status = 1;
      }
      api
        .put(
          `${window.gdEnv.VUE_APP_API_URL}/groovedigital/ad/${this.toStatus.id}`,
          {
            image_url: this.toStatus.image_url,
            trigger_url: this.toStatus.trigger_url,
            is_active: status,
          }
        )
        .then((data) => this.showSuccess(data))
        .catch((err) => this.showError(err));
    },
    saveAds() {
      if (this.toEdit) {
        api
          .put(
            `${window.gdEnv.VUE_APP_API_URL}/groovedigital/ad/${this.toEdit.id}`,
            {
              image_url: this.image,
              trigger_url: this.url,
              is_active: this.status,
            }
          )
          .then((data) => this.showSuccess(data))
          .catch((err) => this.showError(err));
      } else {
        api
          .post(`${window.gdEnv.VUE_APP_API_URL}/groovedigital/ad`, {
            image_url: this.image,
            trigger_url: this.url,
            is_active: this.status,
          })
          .then((data) => this.showSuccess(data))
          .catch((err) => this.showError(err));
      }
      this.$refs.sidebar.close();
    },
    deleteAds(ad) {
      this.toDelete = ad;
      this.$refs.deleteModal.open();
    },
    confirmDelete() {
      api
        .delete(
          `${window.gdEnv.VUE_APP_API_URL}/groovedigital/ad/${this.toDelete.id}`
        )
        .then((data) => this.showSuccess(data))
        .catch((err) => this.showError(err));
      this.$refs.sidebar.close();
    },
    showSuccess(data) {
      this.initAds();
      return Notify.success('Success');
    },
    showError(err) {
      return Notify.fail(err.message || 'Error');
    },
  },
};
</script>
